import script from './component-lib.esm2.js';
import normalizeComponent from '../../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "v-stacked-layout",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('button', {
    staticClass: "v-stacked-layout__btn",
    attrs: {
      "type": "button",
      "aria-label": "Expand links",
      "aria-expanded": _vm.isOpen.toString(),
      "aria-controls": _vm.contentId
    },
    on: {
      "click": _vm.handleClick
    }
  }), _vm._v(" "), _c('div', {
    ref: "root",
    staticClass: "v-stacked-layout__inner",
    style: _vm.innerStyles,
    attrs: {
      "id": _vm.contentId,
      "aria-hidden": (!_vm.isOpen).toString()
    }
  }, [_vm._t("default", null, {
    "attrs": {
      tabindex: _vm.isOpen ? '0' : '-1'
    }
  })], 2)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-210a3c60_0", {
    source: ".v-stacked-layout[data-v-210a3c60]{position:relative}.v-stacked-layout__btn[data-v-210a3c60]{display:none;cursor:pointer;appearance:none;border:none;background:0 0;padding:0;position:absolute;height:100%;width:100%;top:0;left:0;z-index:1}.v-stacked-layout__inner[data-v-210a3c60]{position:relative;transition:height var(--g-duration-complex) var(--c-easing);z-index:0}.v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper{transition:transform var(--g-duration-complex) var(--c-easing);top:0;left:0}.v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper:first-child{position:relative;z-index:3}.v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper:not(:first-child){position:absolute;top:0;width:100%}.v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper:nth-child(2){transform:translate(4px,8px);z-index:2}.v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper:nth-child(3){transform:translate(8px,16px);z-index:1}.v-stacked-layout--closed[data-v-210a3c60]{margin-bottom:var(--p-btn-margin-bottom);padding-bottom:1rem}.v-stacked-layout--closed .v-stacked-layout__btn[data-v-210a3c60]{display:block}.v-stacked-layout--closed .v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper:not(:first-child){height:var(--c-btn-height)}.v-stacked-layout--closed .v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper:not(:first-child) .v-profile-btn{height:var(--c-btn-height)}.v-stacked-layout--closed .v-stacked-layout__inner[data-v-210a3c60]>.link-wrapper:nth-child(n+4){visibility:hidden}.v-stacked-layout--closed[data-v-210a3c60] .link-wrapper{margin-bottom:0;padding-bottom:0}.v-stacked-layout--closed[data-v-210a3c60] .v-profile-btn{box-shadow:0 2px 3px 1px var(--c-box-shadow-color);pointer-events:none}.v-stacked-layout--closed[data-v-210a3c60] .site-btn--hollow{background:var(--p-btn-bg-color);color:var(--p-btn-color);border-color:var(--p-btn-bg-color)}.v-stacked-layout--closed[data-v-210a3c60]:focus-within .link-wrapper:nth-child(2),.v-stacked-layout--closed[data-v-210a3c60]:hover .link-wrapper:nth-child(2){transform:translate(4px,10px)}.v-stacked-layout--closed[data-v-210a3c60]:focus-within .link-wrapper:nth-child(3),.v-stacked-layout--closed[data-v-210a3c60]:hover .link-wrapper:nth-child(3){transform:translate(8px,20px)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-210a3c60";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var StackedLayout = __vue_component__;
export { StackedLayout as default };